
function InputLabel(props) 
{
	const { text } = props;
	return (
		<div style={{paddingBottom: 4, fontWeight: 500}}>{text}</div>
	)
}

export default InputLabel;